var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "r-panel",
    { attrs: { disabled: _vm.disabled, title: _vm.title } },
    [
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", md: "4", sm: "4" } },
            [
              _c("r-currency-kind-dropdown", {
                attrs: {
                  model: _vm.value.currencyFrom,
                  label: "Merge Currency",
                },
                on: {
                  "update:model": function ($event) {
                    return _vm.$set(_vm.value, "currencyFrom", $event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "2", md: "2" } },
            [
              _c("v-text-field", {
                attrs: { label: "Amount", "hide-details": "" },
                model: {
                  value: _vm.model.amount,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "amount", _vm._n($$v))
                  },
                  expression: "model.amount",
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "4", sm: "4" } },
            [
              _c("r-currency-kind-dropdown", {
                attrs: { model: _vm.value.currencyTo, label: "Ball Currency" },
                on: {
                  "update:model": function ($event) {
                    return _vm.$set(_vm.value, "currencyTo", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }